<template>
    <transition-group name="fade">
        <div class="confirm-content" v-if="data.show">
            <div class="title" v-if="props.title">{{props.title}}</div>
            <div class="msg" v-html="props.msg"></div>

            <div class="ctl flex f-sa">
                <button class="btn cancel"
                        @click="props.cancel && props.cancel()">取消</button>
                <template v-if="props.tpl">
                    <wx-open-subscribe
                            @success="props.ok && props.ok()"
                            @error="props.ok && props.ok()"
                            :template="props.tpl"
                            id="subscribe-btn">
                        <component :is="'script'" type="text/wxtag-template" slot="style">
                            <component :is="'style'">
                                .subscribe-btn {
                                border-radius: 20px 20px 20px 20px;
                                border: 1px solid #40D9C7;
                                background-color: #40D9C7;
                                color: #fff;
                                padding: 10px 5px;
                                min-width: 98px;
                                font-size: 14px;
                                }
                            </component>
                        </component>
                        <component :is="'script'" type="text/wxtag-template">
                            <button class="subscribe-btn">确认</button>
                        </component>
                    </wx-open-subscribe>
                </template>
                <button v-else class="btn ok"
                        @click="props.ok && props.ok()">确认</button>

            </div>
        </div>
        <div class="confirm-bg" v-if="data.show"></div>
    </transition-group>
</template>
<script setup>

    import {ref, reactive, onMounted} from 'vue';
    let props = defineProps({
        title: String,
        msg: String,
        ok: Function,
        cancel: Function,
        okStr: {type: String, default: '确认'},
        cancelStr: {type: String, default: '取消'},
        tpl: String,
    })
    let data = reactive({
        show: false,
    })

    onMounted(() => {
        data.show = true;
    })

    defineExpose({
        hide() {
            data.show = false;
        }
    })

</script>
<style lang="scss">

</style>
